

(function(factory) {

//   if (typeof define === 'function' && define.amd) {
//     // AMD. Register as anonymous module.
//     define(['jquery'], factory);
    
//   } else if (typeof exports === 'object') {
//     // CommonJS
//     // Browser globals.
//     factory($);
//   }

  factory($);


}(function($) {
    
    // Register Ajax CSRF automatic insert
    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }
    
    $.ajaxSetup({
        beforeSend: function (xhr, settings) {
            if (!csrfSafeMethod(settings.type)) {
                xhr.setRequestHeader("X-CSRFToken", getCookie('csrftoken_accounts'));
            }
        }
    });

}));